import React from "react";

import {
  ComponentSwitch,
  WrapperSwitch,
} from "@/components/autonomos/core/component-dictionary";

const SectionLayout = ({ layout, value, items }) => {
  return (
    <div className="config-layout-selector">
      <WrapperSwitch reference={layout} {...value}>
        {items &&
          items.map((item, i) => {
            if (item) {
              return (
                <ComponentSwitch reference={item?.type} {...item?.value} />
              );
            }
          })}
      </WrapperSwitch>
    </div>
  );
};

export default SectionLayout;
